<!--begin::Logo image-->
<a routerLink="/home">
  @if (currentLayoutType === 'dark-sidebar') {
  <app-brand-logo [light]="true"></app-brand-logo>
  } @if (currentLayoutType !== 'dark-sidebar') {
  <app-brand-logo [light]="true"></app-brand-logo>
  }

  <app-brand-logo></app-brand-logo>
</a>
<!--end::Logo image-->

@if (toggleEnabled) {
<!--begin::Sidebar toggle-->
<div
  id="kt_app_sidebar_toggle"
  class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
  [ngClass]="toggleButtonClass"
  data-kt-toggle="true"
  [attr.data-kt-toggle-state]="toggleState"
  data-kt-toggle-target="body"
  [attr.data-kt-toggle-name]="toggleAttr"
  (click)="toggleClick()"
>
  <app-keenicon
    name="double-left"
    class="fs-2 rotate-180 {{ isToggle ? 'rotate-active' : 'rotate-back' }}"
  ></app-keenicon>
</div>
<!--end::Sidebar toggle-->
}
